import { SlantedShelf } from "../domain";


export const
    // 15 degrees in radians
    SHELF_ANGLE = 0.2617993877991494,
    SINE_SHELF_ANGLE = 0.25881904510252074,
    FENCE_INSET = 0.5;


/**
 * The vertical distance between the front-bottom edge and the back-bottom edge.
 */
export const getSlantedShelfRakeHeight = (shelf: SlantedShelf): number => {
    return SINE_SHELF_ANGLE * shelf.depth
}

/**
 * The vertical distance between the front-bottom edge and the back-top edge.
 */
export const getSlantedShelfHeight = (shelf: SlantedShelf): number => {
    return getSlantedShelfRakeHeight(shelf) + shelf.thickness;
};
